const ipcRenderer = window.electronAPI ? window.electronAPI : null;

export const saveFile = async (filePath, content) => {
  if (!ipcRenderer) {
    console.error("❌ Electron API nicht verfügbar!");
    return null;
  }
  return await ipcRenderer.invoke("save-file", { filePath, content });
};

export const readFile = async (filePath) => {
  if (!ipcRenderer) {
    console.error("❌ Electron API nicht verfügbar!");
    return null;
  }
  return await ipcRenderer.invoke("read-file", filePath);
};

export const deleteFile = async (filePath) => {
  if (!ipcRenderer) {
    console.error("❌ Electron API nicht verfügbar!");
    return null;
  }
  return await ipcRenderer.invoke("delete-file", filePath);
};

export const showSaveDialog = async () => {
  if (!ipcRenderer) {
    console.error("❌ Electron API nicht verfügbar!");
    return null;
  }
  return await ipcRenderer.invoke("show-save-dialog");
};

export const showOpenDialog = async () => {
  if (!ipcRenderer) {
    console.error("❌ Electron API nicht verfügbar!");
    return null;
  }
  return await ipcRenderer.invoke("show-open-dialog");
};
